module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMcAAAAECAYAAAA6eSvcAAABQklEQVRIiZVXWxICMQgL3SN5Wk9bP7SKmQTYzux0oRCgPFbj8dwIYG0AAAK/PT/MY3o1OutDKzmHoWSXeF+FjYt4bj/vjq7OGG961mFPeA6H92sYb3XH54HQVXhVbtgG563Kv5KF0IPQz/JLyGT6DbSBT29897wUL4M5GcaIRibjBGGyPbZ9Hrbh7HK80dCsp86q+8h42XZlt7IdZne8Kr8se2iH4+4m81R9cBG6dWTyHWQe8J/zfD6pMWVLroX/gO8acQnIlwHiVw5OilLRVXKdTYXXFWuFWS3GY37nH8ur+5hiV3guPpVn5aNqblXY7IMbas5GV6fso6oP9nOngw38PkHsuJpSbrkJwc3QfWm6gndTKct3E1Lp5L1rQuXbnYaZxtgtleyJrtO7E4OSnTbKZKgp2eqXgRq67OM4rvT3Il4vAm7RgKsOJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/left-line.png
// module id = FVY3
// module chunks = 0